module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Arrival or departure time":"Ankunfts- oder Abfahrtszeit","Arrive by":"Ankunft vor","Depart at":"Abfahrt um","Hour":"Stunde","Minute":"Minute","Today":"Heute","Another day":"Ein anderer Tag","Date":"Datum","Time":"Uhrzeit"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/routing/DateTimePicker.vue
// module id = qxrc
// module chunks = 1